import CityPageTemplate from "../city-template/CityPageTemplate";
import { renoConfig } from "./data";

export default function RenoPage() {
  return <CityPageTemplate config={renoConfig} />;
}